import React from "react";
import Menu from "@mui/material/Menu";

const CustomMenu = ({
  anchorEl,
  handleMenuClose,
  mt,
  ml,
  maxWidth,
  minWidth,
  height,
  top,
  right,
  children,
  borderLeftWidth = "",
  borderRightWidth = "",
  borderBottomWidth = "",
  anchorHorizontal = "right",
  transformHorizontal = "right",
}) => {
  const showPointer = Boolean(
    borderLeftWidth && borderRightWidth && borderBottomWidth,
  );

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: anchorHorizontal,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: transformHorizontal,
      }}
      PaperProps={{
        sx: {
          mt: mt,
          ml: ml,
          borderRadius: 3,
          boxShadow:"0px 1px 4px rgba(0, 0, 0, 0.08)",
          bgcolor: "#ffffff",
          maxWidth: maxWidth,
          minWidth: minWidth,
          height: height,
          border: "1px solid #f0f0f0",
          position: "relative",
          overflow: "visible",
          "&::before": showPointer ? {
            content: '""',
            position: "absolute",
            top: top,
            right: right,
            width: 0,
            height: 0,
            borderLeft: `${borderLeftWidth} solid transparent`,
            borderRight: `${borderRightWidth} solid transparent`,
            borderBottom: `${borderBottomWidth} solid #ffffff`,
            filter:
              "drop-shadow(-2px -1px 2px rgba(0, 0, 0, 0.05)) drop-shadow(2px -1px 2px rgba(0, 0, 0, 0.05))",
            zIndex: 1,
          } : { display: "none" },
        },
      }}
    >
      {children}
    </Menu>
  );
};

export default CustomMenu;
